var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property, query, state } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { classMap } from 'lit/directives/class-map.js';
import { repeat } from 'lit/directives/repeat.js';
import { html, css } from 'lit';
import { booleanDecoder, customElement, PIC, PICText } from '../Internals';
let PICMultiSelect = class PICMultiSelect extends PICText {
    constructor() {
        super();
        this.multiline_ = false;
        this.candidateOptions_ = [];
        this.selectedOptions_ = [];
        this.markedIndex_ = -1;
        this.showOptions = false;
        this.preventBlur = false;
        this.reFocus = false;
        this.updateStarted = false;
    }
    static get styles() {
        const defaultStyle = css `
        .multiselect {            
            position: absolute;
            max-height: 20vh;
            overflow: auto;
            -ms-overflow-style: none;  /* IE and Edge */
            scrollbar-width: none;  /* Firefox */
            border-bottom: 1px solid black;
        }
        .multiselect::-webkit-scrollbar {
            display: none;
        }
        .multiselect_items {
            z-index: 599;
            top: 100%;
            left: 0;
            right: 0;
            color: black;
        }
        .multiselect_index {
            cursor: pointer;
            background-color: #f1f1f1;
            border-left: 1px solid black;
            border-right: 1px solid black; 
        }
        .multiselect_index:hover {
            background-color: dodgerblue;
            color: #f1f1f1;
        }
        .multiselect.multiselect_items{
            overflow-x: hidden;
        }
        .multiselect_items div.multiselect_active {
            background-color: dodgerblue;
            color: #f1f1f1;
        }
        .multiselect_head{
            border-top: 1px solid black;
            font-size: 1em;
            pointer-events: none;
        }
        .multiselect_state{
            text-align: 'right';
            border-top: 1px solid black;
            font-size: 1em;
            cursor: pointer;
        }
        .multiselect_sub{
            font-size: 0.8em;
            pointer-events: none;
        }
        .multiselect_key{
            display: none;
        }
        .multiselect_selected{
            background-color: #B4B4B4;
        }
        .multiselect_marked{
            background-color: dodgerblue;
        }
        
        /* new css */
        .selected_opt{
            border: 1px solid black;
            -webkit-touch-callout: none; /* iOS Safari */
            -webkit-user-select: none; /* Safari */
            -khtml-user-select: none; /* Konqueror HTML */
            -moz-user-select: none; /* Old versions of Firefox */
            -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none;
            flex: none;
            background-color: #f1f1f1;
            font-size: 13.333333px;
            margin-top: 1px;
            margin-bottom: 1px;
            padding-left: 1px;
            padding-right: 1px;
        }
        .selected_opt .close_icon{
            cursor: pointer;
        }
        .inner-input{
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            gap: 3px;
            overflow-x: auto;
            overflow-y: hidden;
            -ms-overflow-style: none;  /* IE and Edge */
            scrollbar-width: none;  /* Firefox */
            background-color: white;
            padding-left: 3px;
        }
        .inner-input::-webkit-scrollbar {
            display: none;
        }
        /*.allow_wrap{
            
        }*/
        .allow_wrap .inner-input{
            flex-wrap: wrap;
            overflow-y: auto;
            overflow-x: hidden;
            min-height: 1.35rem;
            height: fit-content;
        }
        `;
        return css `
          ${super.styles}
          ${defaultStyle}
          `;
    }
    get submitValue() {
        let sv = '';
        this.selectedOptions_.forEach(opt => { sv += opt.key + ','; });
        return sv.slice(0, -1);
    }
    connectedCallback() {
        super.connectedCallback();
        this.eType == 'default' || this.eType == 'text' ? this.eType = 'suggestion' : this.eType = 'old';
    }
    changeHandler(e) {
        this.validateSubmit();
        return super.changeHandler(e);
    }
    /*expandList(e: Event){
        this.findOptions(e);
        this.reFocus = true;
        let ref = this;
        this.preventBlur = true;
        PIC.getInstance.addEventListener('click', (e: MouseEvent)=>{
            if (!e.composedPath().includes(ref)) {
                if((ref.initValue_ !== ref.submitValue) && !ref.updateStarted) ref.updateStarted = ref.changeHandler(e);
                ref.showOptions = false;
                ref.requestUpdate();
            }
        })
    }*/
    findOptions(e) {
        this.candidateOptions_ = [];
        for (let i = 0; i < this.options.length; i++) {
            let curOpt = this.options[i];
            curOpt.valDisp = html `${curOpt.val}`;
            curOpt.valsubDisp = html `${curOpt.valsub}`;
            this.candidateOptions_.push(curOpt);
        }
        let ref = this;
        PIC.getInstance.addEventListener('click', (e) => {
            if (!e.composedPath().includes(ref)) {
                if ((ref.initValue_ !== ref.submitValue) && !ref.updateStarted)
                    ref.updateStarted = ref.changeHandler(e);
                ref.showOptions = false;
                ref.requestUpdate();
            }
        });
        this.requestUpdate();
    }
    _selectOption({ key, val, option, first, hide = true }) {
        if (!this.optionContainer)
            return;
        let candidate;
        if (option) {
            candidate = option;
        }
        else if (key) {
            if (this.optionContainer.isValInOptions(key) == 'key') {
                candidate = this.optionContainer.getOption(key);
            }
        }
        else if (val) {
            if (this.optionContainer.isValInOptions(val) == 'val') {
                candidate = this.optionContainer.getOption(this.optionContainer.getKeyfromOptions(val));
            }
        }
        if (candidate) {
            if (!first)
                this.reFocus = true;
            if (this.selectedOptions_.includes(candidate)) {
                this.selectedOptions_.splice(this.selectedOptions_.indexOf(candidate), 1);
                this.requestUpdate();
                return;
            }
            else {
                this.selectedOptions_.push(candidate);
                this.requestUpdate();
            }
            if (hide) {
                this.showOptions = false;
            }
            else {
                this.showOptions = true;
            }
        }
        else {
        }
        this.validateSubmit();
        this.requestUpdate();
    }
    dataReady() {
        if (this.value) {
            if (this.value.length > 0) {
                let ref = this;
                setTimeout(() => {
                    ref.value.split(',').forEach((k) => { ref._selectOption({ key: k, first: true }); });
                    this.initValue_ = this.submitValue;
                }, 20);
            }
        }
    }
    updated(_changedProperties) {
        if (this.reFocus) {
            setTimeout(() => { this.inputField.focus(); }, 5);
            this.reFocus = false;
        }
        if (this.markedElem_) {
            this.markedElem_.scrollIntoView();
        }
    }
    renderMultiSelect() {
        let ref = this;
        return html `
            ${this.renderCSS(true)}
            <div style=${styleMap(this.getContainerStyle())} class="${classMap(this.classAdder(this.getContainerClassMap(), 'allow_wrap', this.multiline_))}">
                <label class=${classMap(this.getInputLabelClass())} for=${this.id}>${this.label}</label>
                <div 
                    class="${classMap(this.getInnerInputClass())}"
                    id="inner_input" 
                    tabindex="0"
                    @focus=${(e) => { this.showOptions = true; this.findOptions(e); }}
                    @keydown=${handleKeypress} 
                    @mousedown=${handleClick}
                    @blur=${(e) => {
            if (!ref.preventBlur) {
                ref.showOptions = false;
                if ((this.initValue_ !== this.submitValue) && !this.updateStarted)
                    this.updateStarted = super.changeHandler(e);
            }
            ref.preventBlur = false;
            ref.requestUpdate();
        }}
                    >
                    ${repeat(this.selectedOptions_, (opt, index) => this.renderDispOption(opt, index))}
                </div>
                ${this.showOptions ? html `
                    <div id="multiselect_list" class="multiselect multiselect_items" @blur=${() => { ref.showOptions = false; ref.requestUpdate(); }}>
                        ${repeat(this.candidateOptions_, (item, index) => this.renderMultiSelectOption(item, index))}
                    </div>` : this.renderErr(this.showFullError)}
                
            </div>
            ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
        `;
        function handleClick(e) {
            ref.showOptions = true;
            ref.findOptions(e);
        }
        function handleKeypress(e) {
            if (ref.markedIndex_ > ref.candidateOptions_.length - 1)
                ref.markedIndex_ = ref.candidateOptions_.length - 1;
            ref.prevInp = ref.inputField.value;
            switch (e.code) {
                case 'ArrowUp':
                    e.preventDefault();
                    e.stopPropagation();
                    if (ref.markedIndex_ > 0)
                        ref.markedIndex_--;
                    ref.showOptions = true;
                    break;
                case 'ArrowDown':
                    e.preventDefault();
                    e.stopPropagation();
                    if (ref.markedIndex_ < ref.candidateOptions_.length - 1)
                        ref.markedIndex_++;
                    ref.showOptions = true;
                    break;
                case 'NumpadEnter':
                case 'Enter':
                    e.preventDefault();
                    e.stopPropagation();
                    if (ref.showOptions && ref.markedIndex_ > -1) {
                        ref._selectOption({ key: ref.candidateOptions_[ref.markedIndex_].key, hide: false });
                    }
                    else {
                        ref._selectOption({ val: ref.inputField.value, hide: false });
                        ref.enterSubmit(e);
                    }
                    break;
                case 'Escape':
                    ref.showOptions = false;
                    break;
                case 'Tab': break;
                default:
                    ref.showOptions = true;
                    break;
            }
            ref.requestUpdate();
        }
    }
    renderMultiSelectOption(iOpt, index) {
        let classes = {
            multiselect_index: true,
            multiselect_marked: (index == this.markedIndex_),
            multiselect_selected: (this.selectedOptions_.includes(iOpt))
        };
        let ref = this;
        function clickfunc(e) {
            if (e.button == 0) {
                ref.preventBlur = true;
                ref._selectOption({ option: iOpt, hide: false });
                ref.requestUpdate();
            }
            else {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        }
        return html `<div class=${classMap(classes)} @mousedown=${clickfunc}>
            <div class="multiselect_head">${iOpt.valDisp}</div>
            ${iOpt.valsub ? html `<div class="multiselect_sub">${iOpt.valsubDisp}</div>` : ''}
            <div class="multiselect_key">${iOpt.key}</div>
        </div>`;
    }
    renderDispOption(iOpt, index) {
        let ref = this;
        return html `<div class="selected_opt">${iOpt.val} <span class="close_icon" @click=${() => { ref._selectOption({ option: iOpt }); }}>&times;</span></div>`;
    }
    render() {
        this.setComponentInlineStyle();
        return this.renderMultiSelect();
    }
};
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'multiline', converter: booleanDecoder })
], PICMultiSelect.prototype, "multiline_", void 0);
__decorate([
    query('.multiselect_marked')
], PICMultiSelect.prototype, "markedElem_", void 0);
__decorate([
    state()
], PICMultiSelect.prototype, "candidateOptions_", void 0);
__decorate([
    state()
], PICMultiSelect.prototype, "selectedOptions_", void 0);
PICMultiSelect = __decorate([
    customElement('pic-multiselect')
], PICMultiSelect);
export { PICMultiSelect };
//# sourceMappingURL=PICMultiSelect.js.map